@use '../../scss/utility/functions' as utility;
@use './checkbox-vars';

$_indeterminate-box-width: utility.wb-pixel-to-rem(12px);
$_indeterminate-box-height: utility.wb-pixel-to-rem(2px);

:host {
  @include checkbox-vars.wb-checkbox-vars;

  display: block;
}

:host(:hover:not([disabled])) {
  @include checkbox-vars.wb-checkbox-hover-vars;
}

:host(:focus-within) {
  @include checkbox-vars.wb-checkbox-focus-vars;
}

input:active ~ .indicator {
  @include checkbox-vars.wb-checkbox-active-vars;
}

input:checked,
input:indeterminate {
  & ~ .indicator {
    @include checkbox-vars.wb-checkbox-checked-vars;
  }
}

:host(:not([disabled]):hover) {
  input:checked,
  input:indeterminate {
    & ~ .indicator {
      @include checkbox-vars.wb-checkbox-checked-vars;
    }
  }
}

input:checked:focus,
input:indeterminate:focus {
  & ~ .indicator {
    @include checkbox-vars.wb-checkbox-checked-focus-vars;
  }
}

input:checked:active,
input:indeterminate:active {
  & ~ .indicator {
    @include checkbox-vars.wb-checkbox-checked-active-vars;
  }
}

:host([error]) {
  @include checkbox-vars.wb-checkbox-error-vars;
}

:host([error]:hover:not([disabled])) {
  @include checkbox-vars.wb-checkbox-error-hover-vars;
}

:host([error]:focus-within) {
  @include checkbox-vars.wb-checkbox-error-focus-vars;
}

:host([error]) input:active ~ .indicator {
  @include checkbox-vars.wb-checkbox-error-active-vars;
}

:host([error]) {
  input:checked,
  input:indeterminate {
    & ~ .indicator {
      @include checkbox-vars.wb-checkbox-checked-error-vars;
    }
  }
}

:host([error]:hover:not([disabled])) {
  input:checked,
  input:indeterminate {
    & ~ .indicator {
      @include checkbox-vars.wb-checkbox-checked-error-hover-vars;
    }
  }
}

:host([error]:focus-within) {
  input:checked,
  input:indeterminate {
    & ~ .indicator {
      @include checkbox-vars.wb-checkbox-checked-error-focus-vars;
    }
  }
}

:host([error]) {
  input:checked:active,
  input:indeterminate:active {
    & ~ .indicator {
      @include checkbox-vars.wb-checkbox-checked-error-active-vars;
    }
  }
}

label {
  display: inline-block;
  position: relative;
  color: var(--checkbox-text-color);
  padding-inline-start: calc(var(--checkbox-size) + var(--checkbox-gap));
  cursor: pointer;
}

input {
  position: absolute;
  width: var(--checkbox-size);
  height: var(--checkbox-size);
  inset-inline-start: 0;
  inset-block-start: 0;
  margin: 0;
  opacity: 0;
  padding: 0;

  &:indeterminate ~ .indicator {
    &::after {
      display: block;
      position: absolute;
      content: '';
      width: $_indeterminate-box-width;
      height: $_indeterminate-box-height;
      background-color: var(--checkbox-icon-color);
    }
  }

  &:not(:checked) ~ .indicator {
    color: transparent;
  }

  &:not(:disabled):focus ~ .indicator,
  &:not(:disabled):active ~ .indicator {
    outline: var(--checkbox-border-weight) solid var(--checkbox-border-ring-color);
    outline-offset: utility.wb-pixel-to-rem(1px);
    border-radius: var(--checkbox-border-ring-radius);
  }
}

.indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  box-sizing: border-box;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: var(--checkbox-size);
  height: var(--checkbox-size);
  background-color: var(--checkbox-background-color);
  border-radius: var(--checkbox-border-radius);
  border: var(--checkbox-border-weight) solid var(--checkbox-border-color);
  color: var(--checkbox-icon-color);
}

.icon {
  --size: var(--checkbox-icon-size);
}

:host([disabled]) {
  label,
  input {
    cursor: not-allowed;
    pointer-events: none;
    opacity: var(--checkbox-opacity-disabled);
  }
}

::slotted(.wb-control-error),
::slotted(.wb-control-hint) {
  padding-inline-start: calc(var(--checkbox-size) + var(--checkbox-gap));
  margin-block-start: var(--checkbox-text-gap);
}

::slotted(.wb-control-hint) {
  color: var(--checkbox-hint-text-color);
}

input,
label {
  -webkit-tap-highlight-color: transparent;
}
